module.exports = __webpack_public_path__ + "static/media/how-it-works-step-2.9c5d1aff.jpg";